import React, { useState } from "react";
import { Skeleton } from "@mui/material";
import * as S from "./styles";
import UserAvatar from "../userAvatar";
import PersonalDataForm from "./personalDataForm";
import PasswordForm from "./passwordForm";
import { useUserContext } from "../../contexts/user/userContext";
import { useLogout } from "../../contexts/user/useLogout";
import { canShare, copyText, shareUserCode } from "../../utils/user";

const Settings: React.FC = () => {
  const { state } = useUserContext();
  const { user } = state;
  const logout = useLogout();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!user) return;
    if (await copyText(String(user.code))) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    }
  };

  // Os formulários só montam com o usuário carregado, para começarem
  // preenchidos com os dados atuais
  if (!user) {
    return (
      <S.Container aria-busy>
        <Skeleton
          variant="rounded"
          height={150}
          sx={{ borderRadius: "16px", mb: 3 }}
        />
        <Skeleton variant="rounded" height={240} sx={{ borderRadius: "16px" }} />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.ProfileCard>
        <S.ProfileRow>
          <UserAvatar
            name={user.name}
            code={user.code}
            avatar={user.avatar}
            size={60}
            light
          />
          <S.ProfileInfo>
            <S.ProfileName>{user.name}</S.ProfileName>
            <S.ProfileLogin>@{user.userName}</S.ProfileLogin>
          </S.ProfileInfo>
        </S.ProfileRow>

        <S.CodeRow>
          <S.CodeInfo>
            <S.CodeLabel>Seu código</S.CodeLabel>
            <S.CodeValue>{user.code}</S.CodeValue>
          </S.CodeInfo>
          <S.CodeActions>
            <S.CodeAction type="button" onClick={handleCopy}>
              {copied ? <S.CopiedIcon /> : <S.CopyIcon />}
              {copied ? "Copiado" : "Copiar"}
            </S.CodeAction>
            {canShare() && (
              <S.CodeAction
                type="button"
                onClick={() => shareUserCode(user.code)}
              >
                <S.ShareIcon />
                Compartilhar
              </S.CodeAction>
            )}
          </S.CodeActions>
        </S.CodeRow>
      </S.ProfileCard>

      <S.SectionTitle>Dados pessoais</S.SectionTitle>
      <PersonalDataForm user={user} />

      <S.SectionTitle>Alterar senha</S.SectionTitle>
      <PasswordForm user={user} />

      <S.LogoutButton type="button" onClick={logout}>
        <S.LogoutIcon />
        Sair do app
      </S.LogoutButton>
    </S.Container>
  );
};

export default Settings;
